import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class RefreshRootLayoutMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('RefreshRootLayoutMessage', RefreshRootLayoutMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');